import React, { type FC } from 'react';
import { useRouter } from '@funtech-int/rival-react';

import { ACCEPT_LINK_ACTION_ID } from '@/shared/constants/notifications';
import { useLocale } from '@/shared/hooks/useLocale';
import { ExternalLinkButton } from '@/shared/components/buttons';
import { ImageInfoBlock } from '@/shared/components/ImageInfoBlock/ImageInfoBlock';
import { channelsRoute } from '@/scenarios/channels';

import { InfoBlockPrimaryPurchaseButton } from '../InfoBlockPrimaryPurchaseButton/InfoBlockPrimaryPurchaseButton';
import { usePaywallContext } from '../../../hooks/usePaywallContext';
import { useI18n } from '../../../hooks/useI18n';
import { useYangoOnboardingConfig } from '../../../hooks/useYangoOnboardingConfig';

import { getChannelsBackgroundUrl } from './getChannelsBackgroundUrl';
import { useChannelsTexts } from './useChannelsTexts';

export const TvChannelsInfoBlock: FC = () => {
    const { offer, paymentPlace } = usePaywallContext();
    const i18n = useI18n();
    const { lang } = useLocale();
    const router = useRouter();
    const config = useYangoOnboardingConfig();
    const channelsBackgroundImageUrl = getChannelsBackgroundUrl(lang);
    const { title, subtitle, subtitleMaxWidth, description } = useChannelsTexts();

    const isChannelsInfoBlockEnabled = config?.isChannelsInfoBlockEnabled ?? false;

    if (!isChannelsInfoBlockEnabled) {
        return null;
    }

    return (
        <ImageInfoBlock
            title={title}
            subtitle={subtitle}
            subtitleMaxWidth={subtitleMaxWidth}
            description={description}
            backgroundImage={channelsBackgroundImageUrl}
            primaryButton={
                <InfoBlockPrimaryPurchaseButton
                    offer={offer}
                    paymentPlace={paymentPlace}
                    text=""
                    contentType="TvChannelsInfoBlock"
                    size={52}
                    alignment="default"
                />
            }
            secondaryButton={
                <ExternalLinkButton
                    text={i18n('home__tv_channels__cta__learn_more')}
                    url={router.serialize(channelsRoute())}
                    actionId={ACCEPT_LINK_ACTION_ID}
                    size={52}
                    variant="secondary"
                    theme="dark"
                />
            }
            alignment="start"
        />
    );
};
